module.exports = __webpack_public_path__ + "static/media/signOutGreen.d35f9888.svg";